import { TSpecs } from '@/shared/types/product-types'

export const adaptProperties = (object: TSpecs) => {
	const values = Object.values(object)

	if (!values?.length) return []

	return Object?.values(values[0]?.GROUP_PROPERTIES)?.map(({ name, values }) => ({
		name,
		value: values[0]?.NAME
	}))
}
